"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var AppModule_1 = require("../core/modules/AppModule");

var TransactionConverter_1 = require("./conversions/TransactionConverter");

var TransactionConverterImpl_1 = require("./conversions/TransactionConverterImpl");
/**
 * @author VRu
 */


var TransactionAppModule =
/*#__PURE__*/
function (_AppModule_1$AppModul) {
  _inherits(TransactionAppModule, _AppModule_1$AppModul);

  function TransactionAppModule() {
    var _this;

    _classCallCheck(this, TransactionAppModule);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransactionAppModule).apply(this, arguments));
    /**
     * @inheritDoc
     */

    _this.name = 'TransactionAppModule';
    return _this;
  }

  _createClass(TransactionAppModule, [{
    key: "configure",
    value: function configure() {
      typescript_ioc_1.Container.bind(TransactionConverter_1.TransactionConverter).to(TransactionConverterImpl_1.TransactionConverterImpl).scope(typescript_ioc_1.Scope.Singleton);
    }
  }]);

  return TransactionAppModule;
}(AppModule_1.AppModule);

exports.TransactionAppModule = TransactionAppModule;